// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3c-0C","name":"ConsentHeader_name__1rv-0","birthday":"ConsentHeader_birthday__1k5xr","skeleton":"ConsentHeader_skeleton__1RefC"};